module.exports = __webpack_public_path__ + "img/9788954430586.1307615e.jpg";